import { render, staticRenderFns } from "./OrgMain.vue?vue&type=template&id=5981b461&scoped=true&"
import script from "./OrgMain.vue?vue&type=script&lang=js&"
export * from "./OrgMain.vue?vue&type=script&lang=js&"
import style0 from "./OrgMain.vue?vue&type=style&index=0&id=5981b461&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5981b461",
  null
  
)

export default component.exports